import { Injectable } from '@angular/core';
import { ApiService } from '../..';
import { DatetimeService } from '../../index'

@Injectable()
export class GiamsatrepeaterService {

  APIURL = "api/SendByteTCP/DTT";
  constructor(public api: ApiService, public dateService: DatetimeService) {
  }
  //Lấy dữ liệu
  getData(danhmucid,tungay,sotrang,sodong){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_REPEATER.P_LAYDS_GIAMSAT_REPEATER" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Xuất excel
  exportExcel(tenDanhmuc,danhmucid,tungay) {
    let cols = [];
    let filename = "Giamsatrepeater_" + tenDanhmuc + "_" + tungay + '.xlsx';
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        // { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        // { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        // { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        // { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        // { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label":  "Trạng thái", "horizontalalignment": "left" },
        // { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_REPEATER.P_LAYDS_GIAMSAT_REPEATER_EXCEL" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
      }),
      title: "GIÁM SÁT REPEATER",
      header: tenDanhmuc +" - Ngày: " + tungay,
      filename: filename,
      sheets: 'Giám sát repeater',
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, filename);
  } 
  getDanhSachCamBien(danhmucid,keyword,sotrang,sodong){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_CAMBIEN.P_GET_DS_CAMBIEM" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_keyword: keyword,
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  suaTT_KH(imei,id_cambien,vitri, nguong_canhbao, mataikhoan){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_CAMBIEN.P_SUA_THONGTIN_CAMBIEM" }),
      para: JSON.stringify({
        v_imei: imei,
        v_idcambien: id_cambien,
        v_vitri: vitri,
        v_nguong_canhbao: nguong_canhbao,
        v_mataikhoan: mataikhoan
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  themTT_KH(imei,id_cambien,vitri,mataikhoan){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_CAMBIEN.P_THEM_THONGTIN_CAMBIEM" }),
      para: JSON.stringify({
        v_imei: imei,
        v_idcambien: id_cambien,
        v_vitri: vitri,
        v_mataikhoan: mataikhoan
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getViTriCamBien(imei){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_CAMBIEN.P_GET_VITRI_CAMBIEN" }),
      para: JSON.stringify({
        v_imei: imei
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  getViTri_and_nguong_cb(imei, vitri){
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT_CAMBIEN.P_GET_NGUONG_CB" }),
      para: JSON.stringify({
        v_imei: imei,
        v_vitri: vitri
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }



}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/giam-sat-repeater/giamsatrepeater.service.ts